<template>
  <div
    v-if="question"
    class="c-guided-quiz-question"
  >
    <h1 class="t-heading-4 u-text-align-center">
      {{ question.title }}
    </h1>
    <div class="t-heading-9 u-text-align-center">
      {{ question.subtitle }}
    </div>
    <div class="l-flex l-flex--align-start">
      <guided-quiz-answer
        v-for="(ans, index) in question.answers"
        :key="'j-guided-quiz-question--' + ans.handle + '-' + index"
        :answer="ans"
        :display-alt="displayAlt"
        :allow-multiple="question.multipleAnswers"
        @answer="answerSelected"
      />
    </div>
  </div>
</template>

<script>
import GuidedQuizAnswer from "./GuidedQuizAnswer";
export default {
  name: "GuidedQuizQuestion",
  components: {
    GuidedQuizAnswer
  },
  props:{
    question: {
      type: Object,
      default: null
    },
    displayAlt: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {

    }
  },
  mounted(){

  },
  methods: {
    answerSelected(answer){
      this.$emit("answer", answer);
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-guided-quiz-question{
    @include themify($themes){
      color: themed("foreground");
    }
  }
</style>